document.addEventListener('DOMContentLoaded', function () {
  // Create a GSAP timeline for image animations
  var imageTL = gsap.timeline({
    defaults: {
      duration: 1,
      ease: "expo.out"
    }
  }); //get all banners

  var banners = document.getElementsByClassName('sticker-banner'); //if there are banners

  if (banners && banners.length > 0) {
    //loop through them
    for (var i = 0; i < banners.length; i++) {
      //get the angle of the banner
      var angle = banners[i].getAttribute('data-angle'); //set the initial state of the banner

      gsap.set('#' + banners[i].id + ' .sticker-banner-anim', {
        autoAlpha: 1
      }); //set the initial state of the banner elements

      gsap.set('#' + banners[i].id + ' .sticker-banner-anim .back', {
        rotation: angle == 'right' ? 25 : -25,
        svgOrigin: angle == 'right' ? '0 90' : '0 90',
        x: angle == 'right' ? '+=17' : '-=10',
        y: angle == 'right' ? '-=172' : '+=5'
      }); //set the initial state of the banner elements

      gsap.set('#' + banners[i].id + ' .sticker-banner-anim .maskFront', {
        x: angle == 'right' ? +400 : -400
      }); //set the initial state of the banner elements

      gsap.set('#' + banners[i].id + ' .banner-label', {
        opacity: 0
      });
      gsap.to('#' + banners[i].id + ' .banner-label', {
        opacity: 1,
        duration: 2,
        // Duration of the fade-in effect
        scrollTrigger: {
          trigger: '#' + banners[i].id + ' .banner-label',
          start: 'top 40%',
          // Start the animation when the top of the element is 40% from the top of the viewport
          end: 'top 20%',
          // End the animation when the top of the element is 20% from the top of the viewport
          scrub: true // Smoothly animate the opacity based on scroll position

        }
      }); //set the initial state of the banner elements

      gsap.set('#' + banners[i].id + ' .banner-disclaimer', {
        opacity: 0
      });
      gsap.to('#' + banners[i].id + ' .banner-disclaimer', {
        opacity: 1,
        duration: 2,
        // Duration of the fade-in effect
        scrollTrigger: {
          trigger: '#' + banners[i].id + ' .banner-disclaimer',
          start: 'top 35%',
          // Start the animation when the top of the element is 40% from the top of the viewport
          end: 'top 20%',
          // End the animation when the top of the element is 20% from the top of the viewport
          scrub: true // Smoothly animate the opacity based on scroll position

        }
      }); //set the timeline for the banner

      gsap.timeline({
        scrollTrigger: {
          trigger: banners[i].closest('div[id^="block-"]'),
          start: 'center bottom',
          end: "+=800",
          scrub: 0.3
        },
        defaults: {
          duration: 0.75,
          ease: 'power1.in'
        }
      }).from('#' + banners[i].id + ' .sticker-banner-anim .maskBack, #' + banners[i].id + ' .sticker-banner-anim .maskFront, #' + banners[i].id + ' .sticker-banner-anim .textBack, #' + banners[i].id + ' .sticker-banner-anim .back', {
        x: angle == 'right' ? '-=400' : '+=400'
      });
    }
  }
});